
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cost-saving",
      function () {
        return require("private-next-pages/cost-saving/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cost-saving"])
      });
    }
  